import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../Shared/API/config';

export const paymentsSlice = createApi({
  reducerPath: 'payments',
  baseQuery,
  endpoints: builder => ({
    getpayments: builder.query<any, void>({
      query: () => '/all',
    }),
    createPayment: builder.mutation<any, any>({
      query: newPayment => ({
        url: '',
        method: 'POST',
        body: newPayment,
      }),
    }),
    updatePayment: builder.mutation<any, { id: number; updates: any }>({
      query: ({ id, updates }) => ({
        url: `/${id}`,
        method: 'PUT',
        body: updates,
      }),
    }),
    deletePayment: builder.mutation<void, number>({
      query: id => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetpaymentsQuery,
  useCreatePaymentMutation,
  useUpdatePaymentMutation,
  useDeletePaymentMutation,
} = paymentsSlice;
